import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import Slide from '@mui/material/Slide';
import Toolbar from '@mui/material/Toolbar';
import { TransitionProps } from '@mui/material/transitions';
import React from 'react';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & { children: React.ReactElement },
    ref: React.Ref<unknown>
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

interface IModalProps {
    open: boolean;
    icon?: string | React.ReactNode;
    label?: string;
    template?: string | React.ReactNode;
    close: any;
}

export function FullScreenDialog(props: IModalProps) {
    return (
        <Dialog
            fullScreen
            open={props.open}
            onClose={props.close}
            TransitionComponent={Transition}
            PaperProps={{
                sx: {
                    overflowY: 'unset'
                }
            }}
        >
            <div className="container">
                <div className="row align-items-center justify-content-center">
                    <div className="col col-lg-5">
                        <Toolbar>
                            {props.icon}
                            <IconButton
                                sx={{
                                    position: 'absolute',
                                    left: '95%',
                                    top: '-9%',
                                    backgroundColor: 'transparent',
                                    color: 'gray'
                                }}
                                edge="start"
                                color="inherit"
                                onClick={props.close}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                        </Toolbar>

                        {props.template}

                        <button
                            className="btn btn-primary btn--md btn--full btn--solid btn-primary--solid"
                            type="button"
                            onClick={props.close}
                            aria-label="close"
                        >
                            Fechar
                        </button>
                    </div>
                </div>
            </div>
        </Dialog>
    );
}
